import React, { FunctionComponent, useCallback } from 'react'

import { Checkbox, FlexAnchor, FlexAnchorProps, mdBumps, Typo } from '../atoms'

export interface CheckboxInputProps extends Omit<FlexAnchorProps, 'onChange' | 'ref'> {
  name: string
  id: string
  value: boolean | undefined
  onChange: (value: boolean) => void
}

export const CheckboxInput: FunctionComponent<CheckboxInputProps> = ({
  id,
  name,
  value,
  onChange,
  children,
  ...props
}) => {
  const onInputChange = useCallback(() => onChange(!value), [onChange, value])

  const uniqueId = name + id

  return (
    <FlexAnchor
      onClick={onInputChange}
      data-test={id}
      variant='highlight'
      py={3}
      px={mdBumps}
      width={1}
      justifyContent='flex-start'
      {...props}
    >
      <Checkbox
        name={name}
        data-test={id}
        id={uniqueId}
        value={value}
        onChange={onInputChange}
      />
      <Typo as='label' ml={4} htmlFor={uniqueId} cursor='pointer'>
        {children}
      </Typo>
    </FlexAnchor>
  )
}
